module.exports = "data:image/png;base64,UklGRkgBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSIoAAAABZ8GwbSTFuRvae2aIiGjVOYYxt0TTpKOSTRew/ihBo0NhBkzAYRtJitTHfPd89Mww+Sc43R9DRP8nAD4fT/MmhK6eZmZzJKKr0UGsTBbsoLYkfak9qUxfAtf+8Qxd88eNZB91hA/OaiDYqXXggu7NHsuY1BP5Tm3kELf93X73vk3Ag6RedGUSAABWUDggmAAAAPACAJ0BKhAAEAACADQljAJ0BpzuZ19J/WYolvrQF2wAAP7anLhT5fPxoblftHqhAG3XH+HGRv/i5zufi2Q67FWxxzzJ/+HP1vPFXEq4i31ZIMhIzyYpSJVIG+yaFlJ4/+r+A5/I9jgSbvi/wvHx6sWElwA62zI2zzelDF4x837N/PvxkGxrjesvZBGhOuiwjb3EAE5hAAAA"


//////////////////
// WEBPACK FOOTER
// ./src/Assets/nodes_icons/icon_Blueprint_MouseEvent_16x.png
// module id = 28
// module chunks = 0